module.exports = __webpack_public_path__ + "media/images/MPR_single BW CS5-e83f6a53da9afedfe0887dc9c856adfe.svg";